<template lang="pug">
  main
    NavBarRequisiciones
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Caja Chica &nbsp
              |
              a.button.is-black.is-rounded(@click='backPage')
                i.fas.fa-times
        .columns.column-blanco  
</template>

<script>
  import Loader from '../../shared/Loader.vue'
  import NavBarRequisiciones from '../layout/NavBarRequisicion.vue'
  import { mapState } from 'vuex'
  export default {
    name: 'HomeCajaChica',
    components: { Loader, NavBarRequisiciones },
    data() {
      return {
        isLoading: true
      }
    },
    methods: {
      iniciarComponente() {
        setTimeout(() => {
          this.isLoading = false
        }, 350)
      },
      backPage () {
        this.$router.back()
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin'])
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/CajaChica_Componentes/HomeCajaChica.vue